module.exports = __webpack_public_path__ + "img/racecourse-greyville-turf-1200.b687bf80.svg";